module.exports = __webpack_public_path__ + "static/Shojumaru-3a5aaa0d0217fe59487cbb1adf0727cd.woff2";